export function registerOtpTypeUrl() {
  return `/register-otp-type`;
}



// WEBPACK FOOTER //
// ./src/utils/url/registerOtpTypeUrl.js